import { render, staticRenderFns } from "./danshi2.vue?vue&type=template&id=722f9342&"
import script from "./danshi2.vue?vue&type=script&lang=js&"
export * from "./danshi2.vue?vue&type=script&lang=js&"
import style0 from "./danshi2.vue?vue&type=style&index=0&id=722f9342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports